import { render, staticRenderFns } from "./StartupDashboardStats.vue?vue&type=template&id=26d01a58"
import script from "./StartupDashboardStats.vue?vue&type=script&lang=js"
export * from "./StartupDashboardStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports